'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialYoutubeCircular = function TiSocialYoutubeCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.1 21.9h1.3v6h1.1v-6h1.2v-1h-3.6z m6.2 4.8c-0.2 0.2-0.9 0.7-0.9 0v-4h-1v4.4c0 1.3 1.3 0.9 1.9 0.3v0.5h1v-5.2h-1v4z m3.8-4c-0.6 0-0.9 0.4-0.9 0.4v-2.2h-1.1v7h1.1v-0.4s0.3 0.5 0.9 0.5c0.6 0 1-0.5 1-1.2v-2.8s-0.4-1.3-1-1.3z m-0.1 4c0 0.4-0.2 0.6-0.6 0.4-0.1 0-0.2-0.1-0.2-0.2v-3.2c0-0.1 0.1-0.1 0.2-0.2 0.3-0.1 0.6 0.1 0.6 0.5v2.7z m3.9-0.3c0 0.4-0.2 0.7-0.5 0.7s-0.5-0.2-0.5-0.7v-1h2v-1.3c0-0.5-0.2-0.8-0.5-1.1-0.3-0.2-0.6-0.4-1-0.4s-0.8 0.1-1.1 0.4c-0.3 0.2-0.5 0.6-0.5 1.1v2.3c0 0.5 0.1 0.9 0.4 1.2 0.3 0.3 0.7 0.4 1.1 0.4 0.4 0.1 1-0.1 1.3-0.6 0.1-0.2 0.3-0.5 0.3-1v-0.2h-1v0.2z m-1-2.3c0-0.3 0.1-0.6 0.5-0.6s0.5 0.3 0.5 0.6v0.6h-1v-0.6z m-5.3-19.1c-8.3 0-15 6.7-15 15s6.7 15 15 15 15-6.7 15-15-6.7-15-15-15z m2.7 5.6h1.3v4.5c0 0.3 0.1 0.3 0.2 0.3 0.2 0 0.5-0.2 0.6-0.4v-4.4h1.3v5.9h-1.3v-0.5c-0.2 0.1-0.4 0.3-0.5 0.4-0.3 0.1-0.5 0.2-0.8 0.2-0.3 0-0.5-0.1-0.6-0.3-0.2-0.2-0.2-0.5-0.2-0.8v-4.9z m-4.3 1.6c0-0.9 0.8-1.7 1.7-1.7s1.6 0.8 1.6 1.7v2.8c0 0.9-0.7 1.7-1.6 1.7s-1.7-0.8-1.7-1.7v-2.8z m-3.5-3.6l0.8 2.9 0.9-2.9h1.5l-1.6 4.6v3.3h-1.5v-3.3l-1.6-4.6h1.5z m13.2 20.9c-0.8 0.8-8 0.8-8 0.8s-7.2 0-8.1-0.8c-0.8-0.8-0.8-5-0.8-5s0-4.2 0.8-5c0.9-0.9 8.1-0.9 8.1-0.9s7.1 0 8 0.9c0.9 0.8 0.9 4.9 0.9 5 0 0 0 4.1-0.9 5z m-8.1-13.9c0.3 0 0.5-0.2 0.5-0.4v-3.2c0-0.2-0.2-0.4-0.4-0.4s-0.5 0.2-0.5 0.4v3.2c0 0.2 0.2 0.4 0.4 0.4z' })
        )
    );
};

exports.default = TiSocialYoutubeCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-youtube-circular.js
// module id = 2025
// module chunks = 0